<template>
    <div class="Pay">
        <Header msg='支付详情'/>

        <div class="Pay-show flex flex-j-c-center">
            <span class="show-title">需支付金额(元)</span>
            <p v-if="payUnavailable"><span class="show-price">--</span></p>
            <p v-else>￥<span class="show-price">{{order_price || '0.00'}}</span></p>
        </div>

        <div class="Pay-method">
            <div class="per-line">
                <div class="flex flex-j-c-sb">
                    <p>优惠券</p>
                    <div class="flex flex-j-c-e method-right" @click="toCoupon">
                        <!-- <span style="color:#FABF01" v-if="pageData.is_coupon === 1">{{couponData.name || '暂无'}}</span> -->
                        <!-- <span style="color:#999999" v-if="pageData.is_coupon === 0">无可用</span> -->
                        <span style="color:#999999">无可用</span>
                        <img class="right-icon" :class="judge ? 'rightActive':''" src="@/assets/right.png">
                    </div>
                </div>
            </div>
            <div class="per-line" @click="show = true">
                <div class="flex flex-j-c-sb">
                    <p>支付方式</p>
                    <p style="color:#666666">微信支付</p>
                </div>
            </div>
        </div>

        <mt-button @click.native="handleClick" size="large" :class="(btnJudge || payUnavailable) ? 'bgColor':''" :disabled="payUnavailable">{{payUnavailable ? '订单不可支付' : '确认支付￥' + (order_price || '0.00')}}</mt-button>

        <van-popup
          v-model="show"
          lock-scroll
          @closed='toOrder'
          get-container="#app">
          <div class="pay-mask flex flex-j-c-center">
            <div class="mask-tips">
              <p class="mask-tips-title">上大学，到陈文卫教育</p>
              <p class="mask-tips-desc">恭喜您！已成功缴费！</p>
            </div>
            <img src="@/assets/qrcodestudent.png" style="width:2.50rem" class="mask-img"/>
            <p class="red">长按上方二维码</p>
            <p class="red">关注陈文卫成高服务号，开启学习之旅！</p>
          </div>
        </van-popup>

    </div>
</template>

<script>
import Header from '@/components/Header.vue';
import {PaymentRelated} from '@/api';
import { Toast } from 'mint-ui';
import { Popup } from 'vant';

export default {
  name: 'Pay',
  components: {
    Header
  },
  data() {
    return {
      judge: false, // 选择优惠券按钮旋转控制（弃用）
      couponData: {name: '请选择'}, // 优惠券信息
      orderData: '', // 订单号
      pageData: {}, // 获取的订单信息
      order_price: '0.00', // 订单价格
      // 订单详情没拿到（被归属校验拦下 / 订单不存在 / 接口报错）时为 true。
      // 此时 order_price 仍是初始值 '0.00'，直接渲染出来会显示「需支付金额 ￥0.00」
      // 外加一个「确认支付 ￥0.00」的按钮 —— 看着像系统把金额算成了 0，
      // 其实是压根没取到金额。这个开关用来把金额显示成 -- 并彻底禁用按钮。
      payUnavailable: false, // 订单详情不可用
      btnJudge: false, // 提交按钮是否不可用
      show: false, // 是否显示支付成功弹窗
      isProxy: false, // 是否职工代付（从二维码 URL 进入）
    }
  },
  created() {
    if (sessionStorage.getItem('_couponPay')) {
      this.couponData = JSON.parse(sessionStorage.getItem('_couponPay'));
    }

    // ★ 订单号有两个来源，优先级：URL 参数 > 会话缓存。
    //   1) previewId：收款码二维码里写死的订单号（PreNotRegistered.vue:123 生成
    //      /Pay?previewId=<订单号>），是「本次要付哪一笔」的显式指令，最可信。
    //   2) _needpayOrderNo：本人从 Confirmation 报名成功后写入的会话缓存。
    //
    //   为什么必须做「双候选 + 失败回退」：
    //   职工扫码代付时，他手机上往往残留着上一次帮别人报名留下的 _needpayOrderNo。
    //   旧代码无条件优先读缓存 ⇒ 拿一个过期/已删除/别的订单号去查 ⇒ 后端返回
    //   「订单不存在」⇒ res.code≠0 ⇒ 拿不到 price ⇒ 金额停在 ￥0.00。
    //   而缓存为空的人（谢宗鑫 7331）反而走 URL 分支正常显示 —— 这就是
    //   「同一个人扫同一个码结果不一样」的根因。
    let urlOrderNo = this.$route.query.previewId || '';
    let cacheData = {};
    try {
      cacheData = JSON.parse(sessionStorage.getItem('_needpayOrderNo')) || {};
    } catch (e) {
      cacheData = {};
    }
    let cacheOrderNo = cacheData.order_no || '';

    if (!urlOrderNo && !cacheOrderNo) {
      Toast({ message: '订单不存在，请稍后再试', duration: 1500 });
      this.btnJudge = true;
      return;
    }

    // 从收款码进入 ⇒ 职工代付。同时把订单号回写进会话，避免残留值影响
    // 后续步骤（确认支付 type=2、优惠券、刷新页面）读到旧订单号。
    if (urlOrderNo) {
      this.isProxy = true;
      sessionStorage.setItem('_needpayOrderNo', JSON.stringify({order_no: urlOrderNo, key: 'kq'}));
    }

    let first = urlOrderNo
      ? {order_no: urlOrderNo, key: 'kq'}
      : {order_no: cacheOrderNo, key: cacheData.key};
    // ★ 这里曾经做过「URL 订单查不到就回退到会话缓存里的另一个订单号」，已废弃。
    //   收款码场景下 URL 的订单号是本次付款的唯一指令，回退到缓存 = 把别人的订单
    //   渲染出来：金额、优惠券、收款方全是另一个订单的，职工一点「确认支付」
    //   就替别人付了款，属于资金事故。宁可明确报错，也不能付错单。
    let second = null;

    this.orderData = first;
    this.payMsg({order_no: first.order_no, type: 1, key: first.key}, second);
  },
  methods: {
    // 确认支付
    handleClick() {
      let params = {};
      if (this.couponData.user_coupon_id) {
        params = {order_no: this.orderData.order_no, type: 2, coupon_id: this.couponData.user_coupon_id, key: this.orderData.key}
      } else {
        params = {order_no: this.orderData.order_no, type: 2, coupon_id:0, key: this.orderData.key}
      }

      this.payMsg(params);
    },
    // 跳转优惠券
    toCoupon() {
      // this.$router.push({name:'Coupon', query:{type: 'pay'}})
    },
    /**
     * 调用支付相关
     * tp 订单接口需要的数据（详情参考API文档）
     */
    payMsg(tp, fallback) {
      if (this.btnJudge) return false;
      this.btnJudge = true;
      PaymentRelated(tp).then(res => {
        if (res.code !== 0) {
          // 第一个订单号查不到（典型：会话残留的旧订单号 / 旧 key），
          // 还有备选就静默换号重试一次，两个都失败才提示，避免误报「订单不存在」。
          if (fallback) {
            this.btnJudge = false;
            this.orderData = fallback;
            this.payMsg({order_no: fallback.order_no, type: tp.type, key: fallback.key}, null);
            return;
          }
          if (res.code === 11) {
            Toast({ message: res.msg, duration: 15000 });
          } else {
            Toast({ message: res.msg, duration: 5000 });
            setTimeout(() => {
              let data = null;
              try { data = JSON.parse(localStorage.getItem('cww_data')); } catch (e) { data = null; }
              let uid = data ? data.id : '';
              window.location.href = `${window.location.origin}/home?id=${uid}`;
            }, 5000);
          }
          // 详情都拿不到，别让「确认支付 ￥0.00」还能点。
          // 同时置 payUnavailable：金额显示成 --、按钮变「订单不可支付」并禁用，
          // 避免职工以为系统把金额算成了 0（实际是压根没取到金额）。
          if (tp.type === 1) {
            this.btnJudge = true;
            this.payUnavailable = true;
          }
        } else {this.pageData = res.data;}
        // 原来不管 res.code 是多少都直接读 res.data.price：接口报错时 res.data 为 undefined，
        // 在 then 里抛 TypeError，导致既没提示、遮罩也不消失，页面永远停在「加载中」。
        if (tp.type === 1 && res.code === 0 && res.data) {
          if (this.couponData.user_coupon_id) {
            this.order_price = this.handlePrice(res.data.price, this.couponData.sub_price);
          } else {
            this.order_price = res.data.price;
          }
        } else if (tp.type !== 1) {
          var url = `${window.location.origin}/Order`;
          if (this._tools.isWechat() && res.code === 0) {
            this._tools.wechatPayCallpay(res.data, url).then((e)=>{
              if(e) {this.show=true;}
            });
          } else {
            let str = '请在微信浏览器打开';
            if (res.code !== 0) { str = res.msg; }
            Toast({ message: str, duration: 1500 });
          }
        }
        this.btnJudge = false;
      }).catch(() => {
        // 接口 500 / 网络异常时解锁，否则按钮永久锁死 + 遮罩不消失（表现就是一直「加载中」）。
        // 报错提示由 axios 拦截器统一弹过了。
        this.btnJudge = false;
        // 详情接口直接 500：同样没拿到金额，别渲染出 ￥0.00 让人误以为金额算错了
        if (tp.type === 1) { this.payUnavailable = true; }
      })
    },
    /**
     * 处理价格
     * orPrice 原价格
     * coPrice 优惠价格
     */
    handlePrice(orPrice, coPrice) {
      let pri = 0;
      if (Number(orPrice) < Number(coPrice)) {
        Toast({ message: '所选优惠券金额不能大于订单金额', duration: 1500 });
        this.couponData = {name: '请选择'}
        sessionStorage.removeItem("_couponPay");
        pri = orPrice;
      } else {
        pri = orPrice - coPrice;
      }
      return Number(pri).toFixed(2);
    },
    // 跳转订单页
    toOrder() {
      if (this.isProxy) {
        window.location.href = `${window.location.origin}/Preview/PreEnrolled`
      } else {
        window.location.href = `${window.location.origin}/Order`
      }
    }
  }
};
</script>

<style scoped lang="less">
.Pay{
    min-height: 100vh;
    padding: 0.44rem 0 0.6rem;
    font-size: 0.16rem;
    .mint-button--large{
        position: fixed;
        left: 50%;
        transform: translateX(-50%);
        bottom: 0.3rem;
    }
    .Pay-show{
        flex-direction: column;
        font-size: 0.18rem;
        background: white;
        padding: 0.25rem 0;
        border-top: 1px solid gainsboro;
        .show-title{
            font-size: 0.12rem;
            color: #666666;
            margin-bottom: 0.20rem;
        }
        .show-price{
            font-size: 0.3rem;
            color: #FABF01;
        }

    }
    .Pay-method{
        margin-top: 0.1rem;
        background: white;
        padding: 0 0.2rem;
        &>:last-child{
            border: none;
        }
    }
}
.van-popup--center{
  border-radius: 6px;
  width: 85%;
}
.mask-tips{
  background: #FABF01;
  color: white;
  padding: 0.2rem 0 0.1rem;
  .mask-tips-title{
    font-size: 0.2rem;
  }
}
.pay-mask{
  flex-direction: column;
  border-radius: 6px;
  padding-bottom: 0.1rem; 
  p{
    margin-bottom: 0.1rem;
  }
  .mask-img{
    margin: 0.05rem auto;
  }
}
.red{
  color: red;
  font-weight: bold;
}
</style>
